import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'hu',
    fullName: 'Hungarian',
    nativeName: 'Magyar',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Valami csodálatos jön",
    landing_subtitle: "Az ArgVoid egy alkalmazás- és játékfejlesztő stúdió. Maradj velünk, hamarosan újdonságok érkeznek!",
    select_language: "Válassza a Nyelv lehetőséget",
    search_placeholder: "Nyelvek keresése...",
    terms_title: "Szolgáltatási feltételek",
    policy_title: "Adatvédelmi szabályzat",
    cookies_title: "Cookie-szabályzat",
    terms_content: `
        <strong>1. Feltételek elfogadása</strong><br>
        Az ArgVoid elérésével a jelen Szolgáltatási feltételeket elfogadjuk. Ha ezekkel a feltételekkel nem ért egyet, a szolgáltatást nem szabad használni.<br><br>

        <strong>2. Platformhasználat</strong>X<br>
        Az ArgVoid és alkalmazásai „ahogy vannak” információs és kreatív célokra. A szolgáltatást csak törvényes célra szabad használni.<br>X<br>

        <strong>3. Tiltott magatartás</strong><br>
        Szigorúan tilos a webhely sebezhetőségeinek kihasználása, spamküldés vagy az infrastruktúrához való jogosulatlan hozzáférés kísérlete.<br><br>

        <strong>4. Jogi nyilatkozat</strong><br>
        A platform és a szolgáltatások előzetes értesítés nélkül bármikor módosíthatók. A szolgáltatás üzemidejére vagy elérhetőségére nem vállalunk garanciát.
    `,
    policy_content: `
        <strong>1. Információgyűjtemény</strong><br>
        A platform jelenleg nem igényel felhasználói hitelesítést vagy fiók létrehozását. A látogatóktól nem gyűjtenek aktívan személyes azonosító adatokat (például neveket vagy e-mail címeket).<br><br>

        <strong>2. Használati adatok</strong>X<br>
        Alapvető, névtelen elemzések gyűjthetők a webhely forgalmának megértéséhez és az alkalmazások fejlesztéséhez. Ezek az adatok nem kapcsolódnak egyéni felhasználói identitásokhoz.<br>X<br>

        <strong>3. Harmadik féltől származó szolgáltatások</strong><br>
        Külső szolgáltatók is igénybe vehetők tárhely- és elemzési szolgáltatásokhoz. Ezen megfelelő szolgáltatók adatvédelmi gyakorlata szabályozza az infrastruktúrájukon feldolgozott névtelen adatokat.<br><br>

        <strong>4. Data Security</strong><br>
        Ésszerű biztonsági intézkedéseket hajtanak végre a platform védelme érdekében. Azonban az interneten keresztüli átvitel egyik módja sem teljesen biztonságos.<br><br>
    `,
    cookies_content: `
        <strong>1. Mik azok a cookie-k és a helyi tárolás?</strong><br>
        A cookie-k és a böngésző helyi tárhelye kis adatfájlok, amelyeket az eszköz tárol, hogy emlékezzen a konfigurációs beállításokra a látogatások során.<br><br>

        <strong>2. Használat célja</strong>X<br>
        A Browser LocalStorage szigorúan a konfigurációs beállítások mentésére szolgál, például:<br>
        - Nyelvi beállítások<br>
        - A felhasználói felület konfigurációja (pl. elrendezés vagy téma beállításai) <br>
        - Ideiglenes alkalmazás cache<br><br>

        <strong>3. Nincs Tracking</strong><br>
        A sütiket és a helyi tárhelyet nem használják reklámozási vagy harmadik fél általi követési célokra. Minden tárolt adat szigorúan a platform alapvető funkcióit szolgálja.<br><br>

        <strong>4. Control</strong><br>
        A böngésző adatai bármikor törölhetők a böngésző beállításaiban, ami visszaállítja a helyi konfigurációkat.
    `,
    cookie_consent_text: "Alapvető cookie-kat használunk a webhely megfelelő működésének biztosítására, például a munkamenet aktív megőrzésére, a nyelvi preferenciák mentésére és egyéb egyéni konfigurációkra.",
    read_policy: "Olvassa el a Cookie-szabályzatot",
    support_title: "Lépjen kapcsolatba az ügyfélszolgálattal",
    support_subject_label: "Téma",
    support_message_label: "Üzenet",
    support_submit_button: "Üzenet küldése",
    support_hint: "Megjegyzés: Ez megnyitja az alapértelmezett e-mail alkalmazást az üzenet elküldéséhez.",
    support_success_msg: "Az e-mail alkalmazás megnyitása...",
    support_error_msg: "Nem sikerült elküldeni az üzenetet. Kérjük, próbálja újra később.",
    explorer_title: "Felfedező",
    history_title: "Történelem",
    animation_title: "Animáció",
    config_title: "Konfiguráció",
    tool_mouse: "Kiválasztás (Ctrl+M)",
    tool_brush: "Ecset (Ctrl+B)",
    tool_brush_mode: "Mód váltása (Szilárd/Tiszta)",
    tool_eraser: "Radír (Ctrl+E)",
    tool_brush_size: "Állítsa be az ecset méretét",
    tool_bucket: "Kitöltés (Ctrl+F)",
    tool_eyedropper: "Pipetta",
    tool_grid: "Rács (Ctrl+Shift+B)",
    tool_rotate: "Forgatás (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Transzponálás (Ctrl+Shift+T)",
    label_width: "Szélesség",
    label_height: "Magasság",
    label_frames: "Keretek száma",
    label_animation: "Animációs stílus",
    label_background_color: "Háttérszín",
    label_interval: "Intervallum",
    tool_anim_config: "Animáció konfigurációja",
    label_new_width: "Új szélesség",
    label_new_height: "Új magasság",
    label_apply: "Alkalmazni",
    label_colors: "Színek",
    label_size: "Méret",
    label_tolerance: "Tolerancia",
    val_horizontal: "Vízszintes",
    val_vertical: "Függőleges",
    val_sequence: "Sorrend",
    val_bounce: "Ugrál",
    val_random: "Véletlen",
    val_solid: "Szilárd",
    val_clear: "Világos",
    action_add_sheet: "Új munkalap",
    action_import: "Importálás",
    action_export: "Export",
    action_sort_projects: "Fajta",
    sort_date_old: "A legrégebbi első",
    sort_date_new: "Legújabb első",
    sort_name_az: "Név (A-Z)",
    sort_name_za: "Név (Z-A)",
    action_new_sprite: "Új Sprite",
    action_new_project: "Új Projekt",
    modal_save_all_title: "Mentse el az összes módosítást",
    modal_save_all_desc: "Válassza ki a menteni kívánt eszközöket:",
    modal_save_selected: "Kijelöltek mentése",
    action_saved: "Mentve",
    modal_create_sprite_title: "Új Sprite létrehozása",
    modal_create_project_title: "Új projekt létrehozása",
    modal_add_sheet_title: "Új munkalap hozzáadása",
    modal_rename_sheet_title: "Lap átnevezése",
    modal_rename_sprite_title: "Sprite átnevezése",
    modal_delete_sprite_title: "Sprite törlése",
    modal_delete_project_title: "Projekt törlése",
    modal_delete_sheet_title: "Lap törlése",
    placeholder_sprite_name: "Név",
    placeholder_project_name: "Név",
    placeholder_sheet_name: "Név",
    placeholder_new_name: "Új név",
    action_create: "Teremt",
    action_add: "Hozzáadás",
    action_rename: "Átnevezés",
    action_duplicate: "Másolat",
    action_delete: "Töröl",
    action_cancel: "Mégsem",
    confirm_delete_sprite: "Biztosan törli ezt a sprite-ot?",
    confirm_delete_project: "Biztosan törli ezt a projektet? Az összes sprite eltávolításra kerül.",
    confirm_delete_sheet: "Biztosan törli ezt a lapot?",
    err_select_sprite: "Kérjük, először válasszon egy sprite-ot.",
    err_select_project: "Kérjük, először válasszon egy projektet.",
    err_name_empty: "A név nem lehet üres.",
    err_sprite_exists: "Már létezik ilyen nevű sprite.",
    err_project_exists: "Már létezik ilyen nevű projekt.",
    err_no_content: "Nincs menthető tartalom.",
    err_no_changes: "Nincs mentendő módosítás.",
    err_delete_last_sheet: "Az utolsó lapot nem lehet törölni.",
    err_extract_frames: "Nem sikerült kibontani egyetlen keretet sem.",
    err_indexeddb: "Nem sikerült helyileg menteni. Előfordulhat, hogy böngészője nem támogatja az IndexedDB-t.",
    msg_upload_success: "Sikeres feltöltés: {0}",
    msg_upload_failed: "Sikertelen feltöltés: {0}",
    msg_save_success: "Sikeres mentés.",
    msg_saving: "Megtakarítás...",
    msg_multi_save_result: "{0} elem mentve. {1} hiba.",
    menu_title: "Menü",
    menu_save: "Megtakarítás",
    menu_save_all: "Az összes mentése",
    menu_support: "Lépjen kapcsolatba az ügyfélszolgálattal",
    label_local_storage: "Helyi tárolás",
    label_sign_in: "Jelentkezzen be",
    modal_export_title: "Sprite exportálása",
    label_filename: "Fájlnév",
    label_format: "Formátum",
    action_export_confirm: "Export",
};

export default translations;
